import styled from 'styled-components'
import PageHeader, { PageHeaderProps } from './PageHeader'

interface GradientPageHeaderProps extends PageHeaderProps {
  gradient: boolean
}

const StyledGradient = styled.div`
  :after {
    content: '';
    height: 24px;
    background-image: linear-gradient(
      180deg,
      #f5f4f7 30%,
      rgba(245, 244, 247, 0) 100%
    );
    width: 100%;
    z-index: 10;
    display: flex;
    position: fixed;
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

const GradientPageHeader = (props: GradientPageHeaderProps) => {
  const { children, gradient, ...restProps } = props

  return (
    <>
      <PageHeader {...restProps}>{children}</PageHeader>
      {gradient && <StyledGradient />}
    </>
  )
}

export default GradientPageHeader
